import { enableProdMode, provideZoneChangeDetection } from "@angular/core";
import { platformBrowserDynamic } from "@angular/platform-browser-dynamic";

import { AppModule } from "./app/app.module";
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';

// UPGRADE NOTE (ngx-bootstrap 15 -> 21): ngx-bootstrap removed the `.forRoot()` factory from 
// BsDropdownModule. However, the third-party library `ngx-intl-tel-input` statically calls 
// `BsDropdownModule.forRoot()` when it is imported. To prevent a runtime TypeError during 
// module loading, we monkey-patch a dummy `.forRoot()` method back onto BsDropdownModule here.
(BsDropdownModule as any).forRoot = () => ({
  ngModule: BsDropdownModule,
  providers: []
});

import { environment } from "./environments/environment";

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic()
  .bootstrapModule(AppModule, {
    applicationProviders: [provideZoneChangeDetection()],
  })
  .catch((err) => console.error(err));
